import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle} from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Select,
  Button,
  Space,
  message,
  DatePicker,
  Input,
  InputNumber,
  ConfigProvider
} from "antd";
import { HomeOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import dayjs from "dayjs";
import './index.scss'
import commonFn from "@/utils/commonFn";
import { CustomUploadNew1 } from "@/hocComponents";

const EmployeesInformationModal = forwardRef(({ submitInitFn }, ref) => {
    const [form] = Form.useForm();
    const [type, setType] = useState('add');
    const [oldState, setOldState] = useState({});
    const [modalName, setModalName] = useState('Payment Request');
    const [modalFlag, setModalFlag] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);

    const [existAccountFlag, setExistAccountFlag] = useState(true);
    const [employmentStatusFlag, setEmploymentStatusFlag] = useState(true);
    const [payStatusFlag, setPayStatusFlag] = useState(true);
    const [isMoveInFlag, setIsMoveInFlag] = useState(true);
    
    const [accountList, setAccountList] = useState([]);
    const [supervisorList, setSupervisorList] = useState([]);
        const [CompanyList, setCompanyList] = useState([]);
    
    const [propIdList, setPropIdList] = useState([]);
    const [propertyMoveInList, setPropertyMoveInList] = useState([]);
    const [groupIdList, setGroupIdList] = useState([]);
    const [unitIdList, setUnitIdList] = useState([]);
    const [employmentTitleList, setEmploymentTitleList] = useState([]);
    const [employmentTimeAllowanceList, setEmploymentTimeAllowanceList] = useState([]);
    const [accountId, setAccountId] = useState(null);

    const customUploadNewRef = useRef(null);
    const [filePaths, setFilePaths] = useState([]);

    useImperativeHandle(ref, () => ({
      openModal: ({type, modalName, oldState}) => {
        setType(type)
        if(type !== 'add') setExistAccountFlag(false)
        setModalName(modalName)
        setOldState(oldState)
        setModalFlag(true)
      }
    }));

    const afterOpenChangeFn = (flag) => {
      if(flag){
        getAccountList()
        getSupervisorList()
        getCompanyList()
        getEmploymentTitleList()
        getEmploymentTimeAllowanceList()
        if(type !== 'add'){
          getDetailFn()
          groupIdFn()
        } else {
          propIdFn()
          groupIdFn()
        }
      }else{
        form.resetFields()
        setExistAccountFlag(true)
        setEmploymentStatusFlag(true)
        setPayStatusFlag(true)
        setIsMoveInFlag(true)
        setAccountList([])
        setSupervisorList([])
        setCompanyList([])
        setPropIdList([])
        setPropertyMoveInList([])
        setGroupIdList([])
        setUnitIdList([])
        setEmploymentTitleList([])
        setEmploymentTimeAllowanceList([])
        setAccountId(null)
        setBtnLoading(false)
        setBtnDisabled(false)
      }
    }

    const testFn = async () => {
      // moment([arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]]).format('MM/DD/YYYY')
      // getGroupNameList
    }

    const getDetailFn = async() => {
      if(!oldState?.id) return
      setBtnDisabled(true)
      const apiMatch = {
        'detail': api.employeesInformationDetailView,
        'Edit': api.employeesInformationDetail,
        'EditPropGroup': api.employeesInformationDetailPropView,
        'EditProp': api.employeesInformationDetailPropView,
        'EditGroup': api.employeesInformationDetailPropView,
      }
      const response = await http.get(apiMatch[type], { params: {id: oldState.id}});
      if (response.code === "1") {
        const { hireDate, createTime, updateTime, propList, groupList, moveInProp, moveInUnit, employmentStatus, payStatus, isMoveIn, fileList, accountId } = response.data
        const temp = {
          ...response.data,
          companyWorkIdList: normalizeCompanyWorkIdList(response.data?.companyWorkIdList),
          propIdList: (propList || []).map(item => item.propId),
          groupIdList: (groupList || []).map(item => item.groupId),
          hireDate: hireDate && dayjs(hireDate),
          createTime: createTime && dayjs(createTime),
          updateTime: updateTime && dayjs(updateTime),
        }
        if(propList?.length){
          setPropIdList(propList);
        } else {
          propIdFn('', 'propIdList')
        }
        setPropertyMoveInList(moveInProp)
        setUnitIdList(moveInUnit)
        setEmploymentStatusFlag(employmentStatus === 1)
        setIsMoveInFlag(isMoveIn === 1)
        if(employmentStatus === 2) {
          setPayStatusFlag(false)
        } else {
          setPayStatusFlag(payStatus === 1)
        }
        setAccountId(accountId)
        form.setFieldsValue(temp);
        if(['Edit', 'EditPropGroup', 'EditProp', 'EditGroup'].includes(type) && customUploadNewRef.current){
          const list = (fileList || [])?.map(item => ({ ...item, url: item.allPath, baseUrl: item.allPath, name: item.name || item.fileName, type: item.contentType}))
          customUploadNewRef.current.initUpdateList(list)
        }
      }
      setBtnDisabled(false)
    }

    const submitAddOrEditFn = async(type) => {
      const apiMatch = {
        'add': api.employeesInformationAdd,
        'Edit': api.employeesInformationUpdate,
        'EditPropGroup': api.employeesInformationUpdateAccount,
        'EditProp': api.employeesInformationUpdateAccountProp,
        'EditGroup': api.employeesInformationUpdateAccountGroup,
      }
      setBtnLoading(true)
      const formValues = form.getFieldValue();
      const response = await http.post(apiMatch[type], {
        ...formValues,
        companyWorkIdList: normalizeCompanyWorkIdList(formValues?.companyWorkIdList),
        hireDate: formValues?.hireDate?.format('YYYY-MM-DD') || '',
        fileList: filePaths.filter(item => !item.id),
        accountId: type === 'add' ? formValues?.accountId : accountId
      });
      if (response.code === "1") {
        message.success(`${type === 'add' ? 'New' : 'Edit'} successfully`);
        setModalFlag(false)
        submitInitFn();
      } else {
        commonFn.modalFailedFn(response)
      }
      setBtnLoading(false)
    }

    const submitFn = async() => {
      form.validateFields().then(value => {
        if(['add', 'Edit', 'EditPropGroup', 'EditProp', 'EditGroup'].includes(type)){
          submitAddOrEditFn(type)
        }
      }).catch(err =>{
        console.log(err,'===err');
      })
    }

    const getAccountList = async () => {
      const response = await http.get(api.employmentTitleAccount );
      if (response?.code === "1") {
        setAccountList(response?.data || []);
      }
    };

    const normalizeCompanyWorkIdList = (value) => {
      if (!Array.isArray(value)) return [];
      return value
        .map((item) => {
          if (item && typeof item === "object") {
            return item.companyId ?? item.value ?? item.id;
          }
          return item;
        })
        .filter((item) => item !== undefined && item !== null && item !== "");
    };

    const getSupervisorList = async () => {
      const response = await http.get(api.getSupervisorNameDict);
      if (response?.code === "1") {
        setSupervisorList(response?.data || []);
      }
    };

    
        const getCompanyList = async () => {
      const response = await http.get(api.getCompanyDictList);
      if (response?.code === "1") {
        setCompanyList((response?.data || []).map((item) => ({
          label: item.companyNameCode,
          value: item.companyId,
        })));
      }
    };
    const propIdFn = async (content = "", type = "") => {
      const response = await http.get(api.propSearch, { params: { content } });
      if (response.code === "1") {
        if(type === 'propIdList'){
          setPropIdList(response?.data || []);
        } else if(type === 'propertyMoveIn'){
          setPropertyMoveInList(response?.data || []);
        } else {
          setPropIdList(response?.data || []);
          setPropertyMoveInList(response?.data || []);
        }
      }
    };

    const groupIdFn = async () => {
      const response = await http.get(api.getGroupList);
      if (response.code === "1") {
        setGroupIdList(response?.data || []);
      }
    };

    const unitIdFun = async (id, content = "") => {
      setUnitIdList([]);
      const propId = id || form.getFieldsValue()?.propertyMoveIn
      if(!propId) return
      const response = await http.get(api.unitSearch, { params: { propId, content } });
      if (response.code === "1") {
        setUnitIdList(response?.data || []);
      }
    };

    const getEmploymentTitleList = async () => {
      const response = await http.get(api.employmentTitleDropdown);
      if (response?.code === "1") {
        setEmploymentTitleList(response?.data || []);
      }
    };

    const getEmploymentTimeAllowanceList = async () => {
      const response = await http.get(api.employeesTimeAllowanceDropdown, {params: {type: 'RENT_CREDIT'}});
      if (response?.code === "1") {
        setEmploymentTimeAllowanceList(response.data || []);
      }
    };

    const deleteOldFn = async(file) => {
      let flag = false
      const response = await http.get(api.employmentDelFile, { params: {id: file.id} });
      if (response.code === "1") {
        flag = true
      }
      return flag
    }
    
    const addOldFn = async(file) => {
      setBtnDisabled(true)
      const list = [file[file.length - 1]]
      const formData = new FormData();
      list.forEach((item) => formData.append("files", item.originFileObj));
      const response = await http.post(api.employmentUploadCommonFile, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.code === "1") {
        return {
          flag: true,
          fileData: response.data[0]
        }
      } else {
        return {
          flag: false,
          fileData: {}
        }
      }
    }

  return (
    <Modal
      title={
        <div style={{ fontSize: "24px", fontWeight: "bold", color: "#3c8dbc" }}>
          <HomeOutlined style={{ marginRight: "8px" }} />
          {modalName}
          <div
            style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
          ></div>
        </div>
      }
      className="EmployeesInformationModal"
      centered
      open={modalFlag}
      onCancel={() => setModalFlag(false)}
      footer={null}
      maskClosable={false}
      afterOpenChange={afterOpenChangeFn}
      width="80%"
    >
      <ConfigProvider componentDisabled={['EditPropGroup', 'EditProp', 'EditGroup', 'detail'].includes(type)}>
        <Form
          form={form}
          layout="horizontal"
          labelCol={{span: 8}}
          wrapperCol={{span: 16}}
          labelWrap={true}
          labelAlign="right"
          initialValues={{
            existAccount: 1,
            employmentStatus: 1,
            isMoveIn: 1
          }}
          validateMessages={{
            required: "${label} is required!",
          }}
        >
          <Row gutter={[16, 16]}>
            <Col span={6}>
              <ConfigProvider componentDisabled={['Edit', 'EditPropGroup', 'EditProp', 'EditGroup', 'detail'].includes(type)}>
                <div
                  style={{
                    marginBottom: "16px",
                    fontWeight: "600",
                    fontSize: "20px",
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  {commonFn.iconDocFn({iconKey: "EmployeesInfoAccountInfo", width: 32, height: 32, marginRight: 6})}
                  Account Info
                </div>
                
                {['add'].includes(type) && <Form.Item
                  name="existAccount"
                  label="Exist Account"
                  rules={[{ required: true, message: 'Exist Account is required!' }]}
                >
                  <Select
                    placeholder="Select a type"
                    optionFilterProp="label"
                    onChange={val => setExistAccountFlag(val === 1)}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={[
                      {label: 'Yes', value: 1},
                      {label: 'No', value: 0},
                    ]}
                  />
                </Form.Item> || null}

                {
                  existAccountFlag ? (
                    <Form.Item
                      name="accountId"
                      label="Account Id"
                      rules={[{ required: true, message: 'Account Id is required!' }]}
                    >
                      <Select
                        showSearch
                        placeholder="Select a type"
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          (option?.roleAllName ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        fieldNames={{
                          value: 'accountId',
                          label: 'roleAllName',
                        }}
                        options={accountList}
                      />
                    </Form.Item>
                  ) : (
                    <>
                      <Form.Item
                        name="email"
                        label="Email"
                        rules={[{ required: true, message: 'Email is required!' }]}
                      >
                        <Input
                          placeholder="Please input Email"
                        />
                      </Form.Item>

                      {['add'].includes(type) && <>
                        <Form.Item
                            name="password"
                            label="Password"
                            rules={[{ required: true, message: 'Password is required!' }]}
                          >
                            <Input.Password
                              placeholder="Please input Password"
                            />
                          </Form.Item>

                          <Form.Item
                            name="confirmPassword"
                            label="Confirm Password"
                            rules={[{ required: true, message: 'Confirm Password is required!' }]}
                          >
                            <Input.Password
                              placeholder="Please input Confirm Password"
                            />
                          </Form.Item>
                      </> || null}

                      <Form.Item
                        name="firstName"
                        label="First Name"
                        rules={[{ required: true, message: 'First Name is required!' }]}
                      >
                        <Input
                          placeholder="Please input First Name"
                        />
                      </Form.Item>

                      <Form.Item
                        name="middleName"
                        label="Middle Name"
                        // rules={[{ required: true, message: 'Middle Name is required!' }]}
                      >
                        <Input
                          placeholder="Please input Middle Name"
                        />
                      </Form.Item>

                      <Form.Item
                        name="lastName"
                        label="Last Name"
                        rules={[{ required: true, message: 'Last Name is required!' }]}
                      >
                        <Input
                          placeholder="Please input Last Name"
                        />
                      </Form.Item>

                      <Form.Item
                        name="cellPhone"
                        label="Cell Phone"
                        rules={[
                          ['add'].includes(type) && { required: true, message: 'Cell Phone is required!' },
                          ['add'].includes(type) && { max: 10, transform: value => String(value), message: "The cell phone has a maximum of 10 characters." } || {},
                        ]}
                      >
                        <InputNumber placeholder="Please input Cell Phone" style={{ width: "100%" }} controls={false} />
                      </Form.Item>

                      <Form.Item
                        name="note"
                        label="Note"
                      >
                        <Input
                          placeholder="Please input Note"
                        />
                      </Form.Item>

                      <ConfigProvider componentDisabled={['EditGroup', 'detail'].includes(type)}>
                        <Form.Item
                          name="propIdList"
                          label="Prop"
                        >
                          <Select
                            showSearch
                            allowClear
                            mode="multiple"
                            placeholder="Select a type"
                            onSearch={val => propIdFn(val, 'propIdList')}
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                              (option?.propName ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            fieldNames={{
                              value: 'propId',
                              label: 'propName',
                            }}
                            options={propIdList}
                          />
                        </Form.Item>
                      </ConfigProvider>

                      <ConfigProvider componentDisabled={['EditProp', 'detail'].includes(type)}>
                        <Form.Item
                          name="groupIdList"
                          label="Group"
                        >
                          <Select
                            showSearch
                            allowClear
                            mode="multiple"
                            placeholder="Select a type"
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                              (option?.groupCode ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            fieldNames={{
                              value: 'groupId',
                              label: 'groupCode',
                            }}
                            options={groupIdList}
                          />
                        </Form.Item>
                      </ConfigProvider>
                    </>
                  )
                }
              </ConfigProvider>

              <div
                style={{
                  marginBottom: "16px",
                  fontWeight: "600",
                  fontSize: "20px",
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                {commonFn.iconDocFn({iconKey: "EmployeesInfoEmployeeInfo", width: 32, height: 32, marginRight: 6})}
                Employees Info
              </div>

              <Form.Item
                name="employeeCode"
                label="Employee Code"
                // rules={[{ required: true, message: 'Employee Code is required!' }]}
              >
                <Input
                  placeholder="Please input Employee Code"
                />
              </Form.Item>

              <Form.Item
                name="supervisorAccountId"
                label="Supervisor Account"
                rules={[{ required: true, message: 'Supervisor Account is required!' }]}
              >
                <Select
                  showSearch
                  placeholder="Select a type"
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    (option?.fullEmailName ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  fieldNames={{
                    value: 'accountId',
                    label: 'fullEmailName',
                  }}
                  options={supervisorList}
                />
              </Form.Item>

              <Form.Item
                name="ssn"
                label="Ssn"
                rules={[
                  { required: true, message: 'Ssn is required!'},
                  {
                    pattern: /^\d{9}$/,
                    message: "Ssn must be exactly 9 digits.",
                  },
                ]}
              >
                <Input placeholder="Please input Ssn" />
              </Form.Item>

              <Form.Item
                name="driverLicense"
                label="Driver License"
              >
                <Input
                  placeholder="Please input Driver License"
                />
              </Form.Item>

              <Form.Item
                name="companyWorkIdList"
                label="Company Work Under"
             rules={[{ required: true, message: 'Company Work Under is required!' }]}
              >
                {/* <Input
                  placeholder="Please input Company Work Under"
                /> */}
                      <Select
                            showSearch
                            allowClear
                            mode="multiple"
                            placeholder="Select a Company Work Under"
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            options={CompanyList}
                          />
              </Form.Item>

              <Form.Item
                name="officeLocation"
                label="Office Location"
              >
                <Input
                  placeholder="Please input Office Location"
                />
              </Form.Item>
              
            </Col>
            <Col span={6}>
              <div
                style={{
                  marginBottom: "16px",
                  fontWeight: "600",
                  fontSize: "20px",
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                {commonFn.iconDocFn({iconKey: "EmployeesInfoEmploymentInfo", width: 32, height: 32, marginRight: 6})}
                Employment Info
              </div>

              <Form.Item
                name="hireDate"
                label="Hire Date"
                rules={[
                    { required: true, message: "Hire Date is required!" },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  format="MM/DD/YYYY"
                />
              </Form.Item>

              <Form.Item
                name="employmentTitleId"
                label="Employment Title"
                rules={[{ required: true, message: 'Employment Title is required!' }]}
              >
                <Select
                  showSearch
                  placeholder="Select a type"
                  optionFilterProp="label"
                  onSelect={(value, option) => {form.setFieldsValue({roleNames: option?.roleNames || []})}}
                  filterOption={(input, option) =>
                    (option?.titleName ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  fieldNames={{
                    value: 'id',
                    label: 'titleName',
                  }}
                  options={employmentTitleList}
                />
              </Form.Item>

              <Form.Item
                name="roleNames"
                label="Role"
              >
                <Select
                  disabled
                  showSearch
                  mode="multiple"
                  // placeholder="Select a type"
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    (option?.titleName ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                />
              </Form.Item>

              <Form.Item
                name="employmentStatus"
                label="Employment Status"
                rules={[{ required: true, message: 'Employment Status is required!' }]}
              >
                <Select
                  placeholder="Select a type"
                  optionFilterProp="label"
                  onChange={val => {
                    setEmploymentStatusFlag(val === 1)
                    form.setFieldsValue({payStatus: val === 2 ? 2 : undefined})
                    if(val === 2) setPayStatusFlag(false)
                  }}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    {label: 'Full Time', value: 1},
                    {label: 'Part Time', value: 2},
                  ]}
                />
              </Form.Item>

              <Form.Item
                name="payStatus"
                label="Pay Type"
                rules={[{ required: true, message: 'Pay Type is required!' }]}
              >
                <Select
                  disabled={!employmentStatusFlag || ['EditPropGroup', 'EditProp', 'EditGroup', 'detail'].includes(type)}
                  placeholder="Select a type"
                  optionFilterProp="label"
                  onChange={val => {
                    setPayStatusFlag(val === 1)
                  }}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    {label: 'Salary', value: 1},
                    {label: 'Hourly', value: 2},
                  ]}
                />
              </Form.Item>

              {['add', 'Edit', 'detail'].includes(type) && commonFn.formInputNumberDoc({
                form,
                name: "payRate",
                label: "Pay Rate",
                allowNegative: true,
                disabled: ['EditPropGroup', 'EditProp', 'EditGroup', 'detail'].includes(type),
                suffix: payStatusFlag ? 'USD/Month' : 'USD/Hour'
              }) || null}

              <Form.Item
                name="contractedHours"
                label="Contracted Hours"
              >
                <InputNumber placeholder="Please input Contracted Hours" style={{ width: "100%" }} controls={false} min={0} precision={2} />
              </Form.Item>

              <div
                style={{
                  marginBottom: "16px",
                  fontWeight: "600",
                  fontSize: "20px",
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                {commonFn.iconDocFn({iconKey: "EmployeesInfoRentalInfo", width: 32, height: 32, marginRight: 6})}
                Rental Info
              </div>

              <Form.Item
                name="isMoveIn"
                label="Is Move ln"
                rules={[{ required: true, message: 'Is Move ln is required!' }]}
              >
                <Select
                  placeholder="Select a type"
                  optionFilterProp="label"
                  onChange={val => {
                    setIsMoveInFlag(val === 1)
                  }}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    {label: 'Yes', value: 1},
                    {label: 'No', value: 0},
                  ]}
                />
              </Form.Item>
              {
                isMoveInFlag && (
                  <>
                    <Form.Item
                      name="propertyMoveIn"
                      label="Property Move ln"
                      rules={[{ required: true, message: 'Property Move ln is required!' }]}
                    >
                      <Select
                        showSearch
                        placeholder="Select a type"
                        onSearch={val => propIdFn(val, 'propertyMoveIn')}
                        onChange={val => (unitIdFun(val), form.setFieldsValue({unitLiveIn: undefined}))}
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          (option?.propName ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        fieldNames={{
                          value: 'propId',
                          label: 'propName',
                        }}
                        options={propertyMoveInList}
                      />
                    </Form.Item>

                    <Form.Item
                      name="unitLiveIn"
                      label="Unit Live ln"
                      rules={[{ required: true, message: 'Unit Live ln is required!' }]}
                    >
                      <Select
                        showSearch
                        placeholder="Select a type"
                        onSearch={val => unitIdFun('', val)}
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          (option?.unitName ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        fieldNames={{
                          value: 'unitId',
                          label: 'unitName',
                        }}
                        options={unitIdList}
                      />
                    </Form.Item>

                    <Form.Item
                      name="rentCreditId"
                      label="Rent Credit"
                      rules={[{ required: true, message: 'Rent Credit is required!' }]}
                    >
                      <Select
                        showSearch
                        placeholder="Select a type"
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          (option?.name ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        fieldNames={{
                          value: 'id',
                          label: 'name',
                        }}
                        options={employmentTimeAllowanceList}
                      />
                    </Form.Item>
                  </>
                ) || null
              }
              
              {['Edit', 'EditPropGroup', 'EditProp', 'EditGroup', 'detail'].includes(type) && (
                <ConfigProvider componentDisabled={['Edit', 'EditPropGroup', 'EditProp', 'EditGroup', 'detail'].includes(type)}>
                  <div
                    style={{
                      marginBottom: "16px",
                      fontWeight: "600",
                      fontSize: "20px",
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    {commonFn.iconDocFn({iconKey: "EmployeesInfoOtherInfo", width: 32, height: 32, marginRight: 6})}
                    Other Info
                  </div>
                  
                  <Form.Item
                    name="createByName"
                    label="Create By"
                  >
                    <Input
                      placeholder="Please input Create By"
                    />
                  </Form.Item>

                  <Form.Item
                    name="createTime"
                    label="Create Date"
                  >
                    <DatePicker
                      showTime
                      style={{ width: "100%" }}
                      format="MM/DD/YYYY HH:mm:ss"
                    />
                  </Form.Item>

                  <Form.Item
                    name="updateByName"
                    label="Modifier"
                  >
                    <Input
                      placeholder="Please input Modifier"
                    />
                  </Form.Item>

                  <Form.Item
                    name="updateTime"
                    label="Modified Date"
                  >
                    <DatePicker
                      showTime
                      style={{ width: "100%" }}
                      format="MM/DD/YYYY HH:mm:ss"
                    />
                  </Form.Item>
                </ConfigProvider>
              ) || null}

            </Col>
            <Col span={12}>
              <div
                style={{
                  marginBottom: "16px",
                  fontWeight: "bold",
                  fontSize: "20px",
                }}
              >
                <HomeOutlined style={{ marginRight: "8px" }} />
                Files
              </div>
              <Form.Item
                name="filePaths" 
                label="Files"
                labelCol={{ span: 0 }} 
                wrapperCol={{ span: 24 }}
                // rules={[{ required: true, message: "Files is required!" }]}
              >
                <CustomUploadNew1
                  ref={(el) => (customUploadNewRef.current = el)}
                  customConfig={{
                    pdfHeight: "76vh",
                    notMultiple: true,
                    accept: ".jpg, .jpeg, .png, .pdf",
                    status: 'add',
                    disabled: false,
                    noUploadBtn: false,
                    deleteOldFn: deleteOldFn,
                    addOldFn: addOldFn
                  }}
                  setFilePaths={setFilePaths} 
                  filePaths={filePaths} 
                  setBtnDisabled={setBtnDisabled}
                  btnDisabled={btnDisabled}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </ConfigProvider>
      {!['detail'].includes(type) && <div style={{textAlign:'center'}}>
        <Space align="center">
          {/* <Button key="back" onClick={testFn}>
            TEST
          </Button> */}
          <Button key="back" onClick={() => setModalFlag(false)}>
            Cancel
          </Button>
          <Button type="primary" onClick={() => submitFn()} loading={btnLoading} disabled={btnDisabled}>
            Submit
          </Button>
        </Space>
      </div> || null}
    </Modal>
  );
});

export default EmployeesInformationModal;
